import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';
import { AlertState } from './types';

export const actions: ActionTree<AlertState, RootState> = {};
